var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.searchFn.apply(null, arguments)}}},[_c('p',[_vm._v(_vm._s(_vm.descPlaceHolder))]),_c('img',{attrs:{"src":require("../images/search.png"),"alt":"搜索icon"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }